import ImageAdjustUI from './ImageAdjustUI';
import { mountVueComponent } from '../../../../shared/components/vue-factory';
import Button from './Button';
import { KEYS } from './consts';
import { translate } from '../../../../shared/services/I18nService';
import { makeDiv } from '../viewport-overlay';

export function makeUserInterface (uScope, store, visibilityPanel) {
  const dialog = createComponent(uScope, store);
  return createUscopeToolbarButton(uScope, dialog, store, visibilityPanel);
}

function createComponent (uScope, store) {
  const { div, id } = makeDiv();
  document.body.appendChild(div);

  return mountVueComponent({
    el: `#${id}`
  },
  ImageAdjustUI, {
    store
  });
}

function createUscopeToolbarButton (uScope, parent, store, visibilityPanel) {
  const dialog = parent.$children[0];
  const { div, id } = makeDiv();
  uScope.topToolbar.addButton(div);
  visibilityPanel && visibilityPanel.addOption({
    key: KEYS.SHOW_BUTTON,
    label: translate('uScope.extensions.image-adjust.show-button')
  }, 8);

  let button = mountVueComponent({
    el: `#${id}`
  },
  Button, {
    store,
    onClick: dialog.toggleVisibility
  });
  button = button.$children[0];

  return button;
}
